import { Box } from '@mui/material'
import React from 'react'
import SettingsMenu from '../../components/settings/SettingsMenu'
import ApiKeyHandler from '../../components/settings/ApiKeyHandler'

const SettingsPage: React.FC = () => {
    return (
        <Box display={"flex"} width={"100%"} justifyContent={"center"} overflow={"auto"}>
            <Box display={"flex"} flexDirection={"column"} maxWidth={"1386px"} margin={"50px 56px"} flexGrow={1}>
                <Box display={"flex"} gap={"20px"}>
                    <SettingsMenu />
                    <ApiKeyHandler />
                </Box>
            </Box>
        </Box>
    )
}

export default SettingsPage